// @flow

import type { Action } from 'app/common/redux/types';
import { track } from 'app/common/lib/react/analytics';
import type { Dispatch, Store } from 'redux';

// $FlowFixMe: New error after Flow Upgrade http://pinch.pinadmin.com/flow53upgdoc
export default () => (next: Dispatch<any>) => (action: Action): Store => {
  if (action.type === 'CONTEXT_LOG_EVENT') {
    const { payload } = action;
    track(payload.name, payload.properties);
  }
  return next(action);
};
